import React from 'react';
import { Text, View } from 'react-native';
import { Card } from 'react-native-paper';
// Common components
import { LabeledField } from '../components/LabeledField';
import { TEXT_FIELD_WIDTH } from '../components/consts';
import { styles } from './ProfileViewStyle';
import { FormCard } from './FormCard';
import { BeverageValuePrefix } from './formValuesModel';
import { FoodCheckboxes } from './FoodCheckboxes';
const formatBeverageLabel = (beverage) => beverage.name;
export const BeveragesCard = ({ beverages, beverageValues, readOnly }) => {
    return (<FormCard>
      <Card.Content>
        <Text style={styles.labelText}>
          What beverages do you currently drink?
        </Text>
        {beverages && (<FoodCheckboxes foods={beverages} valuePrefix={BeverageValuePrefix} values={beverageValues} readOnly={readOnly} labelTransformer={formatBeverageLabel}/>)}
        <View style={styles.row}>
          <LabeledField name="alcoholsDesc" label="Do you drink alcohol?" placeholder="List any types" width={TEXT_FIELD_WIDTH} height={50} multiline={true} readOnly={readOnly}/>
        </View>
      </Card.Content>
    </FormCard>);
};
